// components/tree/ValidationNotice.jsx
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { Box, Typography, alpha } from '@mui/material';
import CollapsibleAlert from './CollapsibleAlert';

const ValidationNotice = ({ validationResult }) => {
  if (!validationResult?.message) return null;

  const hasErrors = validationResult.errorMessages?.length > 0;
  const hasWarnings = validationResult.warningMessages?.length > 0;

  const severity = hasErrors ? 'error' : hasWarnings ? 'warning' : 'success';

  if (severity === 'success') {
    return (
      <Box
        sx={(theme) => ({
          mb: 1,
          px: 1,
          py: 1.15,
          borderRadius: 1.5,
          borderLeft: `6px solid ${theme.palette.success.main}`,
          bgcolor: alpha(theme.palette.success.main, 0.08),
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        })}
      >
        <CheckCircleRoundedIcon color="success" />
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, color: (theme) => theme.palette.text.primary }}
        >
          {validationResult.message}
        </Typography>
      </Box>
    );
  }

  const summary =
    severity === 'error'
      ? 'Valideringsfejl: klik for detaljer'
      : 'Valideringsadvarsel: klik for detaljer';

  return (
    <CollapsibleAlert severity={severity} summary={summary}>
      {validationResult.message}
    </CollapsibleAlert>
  );
};

export default ValidationNotice;
